/** A server timestamp in the viewer's locale ("Sep 26, 2026, 6:48 PM"), or a dash. */
export const formatWhen = (iso) => {
  const date = iso ? new Date(iso) : null;
  return date && !Number.isNaN(date.getTime())
    ? date.toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })
    : '-';
};
